import React from 'react';
import { useParams } from 'react-router-dom';

import ListModelNavigation from '@dashboard/components/ListModelNavigation';

export default function Navigation() {
  const id = useParams<{ id: string }>().id!;
  const getLinkHref = (id: string) => `../events/${id}`;
  return <ListModelNavigation currentModelId={id} backLinkHref="../events" getLinkHref={getLinkHref} />;
}
